<template>
  <div class="product-info ">
    <div class="product-info-header">
      <div class="product-info-header-title">新闻详情</div>
    </div>
    <div class="product-info-content">
      <div style="margin: 15px 0;">
        <span style="cursor: pointer;" @click="close" class="product-info-content-back">新闻中心&ensp;/&ensp; </span> <span
          style="color: rgba(32, 129, 235, 1);">详情页</span>
      </div>
      <div class="product-info-footer-share">
        <FloatActionButton :left="120" :top="100" icon="logoIcon-weui-contacts-filled" @click="handleFabClick" />
      </div>
      <div class="product-info-content-content">
        <div class="product-info-content-content-left">
          <div class="product-info-content-content-left-title">{{ itemInfo.input988275a1 }}</div>
          <div class="product-info-content-content-left-time">
            <div><span>{{ itemInfo.date2f1ad95c }}</span> <span style="margin-left: 10px;">信息来源：{{
              itemInfo.inputab55e1b3
                }}</span></div>
            <div>
              <span>文字:{{ itemInfo.inpute096123c }}</span> <span style="margin: 0 10px;">|</span>
              <span>编辑:{{ itemInfo.input6e1f1979 }}</span> <span style="margin: 0 10px;">|</span>
              <span>责编:{{ itemInfo.input8eb0f84f }}</span>
            </div>
          </div>
          <div class="product-info-content-html" v-if="_html" v-html="_html"></div>
        </div>
        <!-- <div class="product-info-content-content-right">
          <div class="product-info-content-content-right-title">最新新闻</div>
          <div class="product-info-content-content-right-list">
            <div v-for="item in list" :key="item.rowId" class="product-info-content-content-right-list-item"
              @click="changeItem(item)">
              <div class="product-info-content-content-right-list-item-left">
                <div class="product-info-content-content-right-list-item-left-time">{{ getTime(item.date2f1ad95c) }}
                </div>
                <div class="product-info-content-content-right-list-item-left-circle">{{
          getTimeCircle(item.date2f1ad95c) }}
                </div>
              </div>
              <div class="product-info-content-content-right-list-item-right">
                {{ item.input988275a1 }}
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="product-info-content-page">
        <div class="product-info-content-page-button" @click="prevData">
          <span style="white-space: nowrap;"> 上一条 :</span>
          <div class="product-info-content-page-button-text">{{ prev ? prev.input988275a1 : '无' }}</div>
        </div>
        <div class="product-info-content-page-button-right" @click="nextData">
          <span style="white-space: nowrap;"> 下一条 :</span>
          <div class="product-info-content-page-button-text-right">{{ next ?
            next.input988275a1 : '无' }}</div>
        </div>
      </div>
    </div>

    <div class="product-info-footer">
      <a-button class="learnmore-btn" type="primary" @click="close">返回列表</a-button>
    </div>


  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { getFilterList, getRowById, getWXAccessToken } from "@/api/index"
import { useRouter, useRoute } from 'vue-router'
import dayjs from 'dayjs'
import FloatActionButton from '@/components/FloatActionButton.vue';
import { useWxShare } from "@/utils/wxshare"


const props = defineProps({
  itemInfo: {
    type: Object,
    default: () => ({})
  },
  list: {
    type: Array,
    default: () => []
  }
})

const router = useRouter()
const route = useRoute()
const emit = defineEmits(['changeItem', "close"])
const dataInfo = ref([])
const itemInfo = computed(() => props.itemInfo)
const list = computed(() => props.list)
// 
const _html = computed(() => {
  return itemInfo.value["rich-editor353f43a8"] || ""
})

const imgUrl = computed(() => {
  let url = ""
  if (itemInfo.value["picture-uploadc1d6988a"] && itemInfo.value["picture-uploadc1d6988a"].length > 0) {
    url = itemInfo.value["picture-uploadc1d6988a"][0].url
  }
  return url
})

const getTime = (time) => {
  if (time) {
    return dayjs(time).format('YYYY.MM')
  } else {
    return ""
  }
}

const getTimeCircle = (time) => {
  if (time) {
    return dayjs(time).format('DD')
  } else {
    return ""
  }
}


const prev = computed(() => {
  return list.value[list.value.findIndex(item => item.rowId === itemInfo.value.rowId) - 1]
})
const next = computed(() => {
  return list.value[list.value.findIndex(item => item.rowId === itemInfo.value.rowId) + 1]
})



const changeItem = (item) => {
  emit("changeItem", item)
}

const close = () => {

  router.push({
    query: {

    }
  })
  emit("close")
}

function step () {
  window.scrollTo({
    top: (0)
  })
}
function handleScrollTop () {
  window.requestAnimationFrame(step)
}


watch(() => itemInfo.value, () => {
  handleScrollTop()
}, { deep: true })

const nextData = async () => {
  if (next.value) {
    router.push({
      query: {
        id: next.value.rowId
      }
    })
    // getFilter(next.value)
    emit("changeItem", next.value)
  }
}
const prevData = async () => {
  if (prev.value) {
    router.push({
      query: {
        id: prev.value.rowId
      }
    })
    // getFilter(prev.value)
    emit("changeItem", prev.value)
  }
}

const url = computed(() => {
  return `${location.origin}#${route.fullPath}`
})
onMounted(() => {
  handleScrollTop()
  // getData()
})
onMounted(() => {
  let img = `${location.origin}${imgUrl.value}`
  useWxShare(itemInfo.value.input988275a1, itemInfo.value.inputefdc72c4, url.value, img)
})



</script>

<style scoped lang="less">
.product-info {
  font-family: 'PuHuiTi';
  width: 100%;
  height: 100%;
}

.product-info-header {
  width: 100%;
  height: 200px;
  background: url("../../../assets/image/product/itemInfo_bg.png") no-repeat;
  background-size: 100% 100%;
}

.product-info-header-title {
  color: rgba(51, 51, 51, 1);
  font-weight: 500;
  font-size: 32px;
  font-family: 'PuHuiTi';
  margin-left: 18%;
  padding-top: 110px;

}

.product-info-content {
  width: 100%;
  height: 100%;
  padding-left: 18%;
  padding-right: 19%;
  position: relative;
}

.product-info-content-img-bg {

  background: url("../../../assets/image/product/info_bg.png") no-repeat;
  background-size: 100% 100%;
  padding: 30px;
  margin: 30px 0;
}

.product-info-content-title {
  font-size: 22px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);

  background: url("../../../assets/image/product/Line.png") no-repeat;
  background-position: 0% 100%;

}

.product-info-content-jianjie {
  font-size: 14px;
  margin-top: 20px;
  color: rgba(51, 51, 51, 1);
}

.product-info-footer {
  width: 100%;
  display: flex;
  margin-bottom: 30px;
  justify-content: center;
}

.learnmore-btn {

  width: 210px;
  height: 46px;
  margin-right: 1%;
  border-radius: 10px;
}

.product-info-content-page {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}

.product-info-content-page-button {
  width: 45%;
  height: 46px;
  background: rgba(248, 250, 250, 1);
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-left: 10px;
}

.product-info-content-content {
  width: 100%;
  display: flex;
}

.product-info-content-content-left {
  width: 100%;
  height: 100%;
  padding-right: 20px;
}

.product-info-content-content-left-title {
  font-size: 26px;
  color: rgba(51, 51, 51, 1);
  margin: 20px 0;
}

.product-info-content-content-left-time {
  width: 100%;
  height: 64px;
  border-left: 2px solid rgba(236, 236, 236, 1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 20px;
  color: rgba(107, 116, 135, 1);
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 30px;
}

.product-info-content-content-left-time-share {
  width: 100%;
  height: 800px;
  overflow: auto;
  padding-right: 20px;
  margin-top: 50px;
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
}

.product-info-content-content-right {
  width: 25%;
  height: 100%;
}

.product-info-content-content-right-title {
  width: 100%;
  height: 41px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(248, 248, 248, 1);
  font-size: 20px;
  color: rgba(51, 51, 51, 1);
}

.product-info-content-content-right-list {
  height: 800px;
  width: 100%;
  overflow: auto;
}

.product-info-content-content-right-list-item {
  width: 100%;
  height: 65px;
  border-bottom: 1px solid rgba(236, 236, 236, 1);
  display: flex;
  padding-top: 5px;
  cursor: pointer;
  margin: 5px 0;
}

.product-info-content-content-right-list-item-left {
  width: 60px;
  height: 59px;
  border-top: 1px solid rgba(236, 236, 236, 1);
  border-left: 1px solid rgba(236, 236, 236, 1);
  border-right: 1px solid rgba(236, 236, 236, 1);
  display: flex;
  flex-direction: column-reverse;
  padding-right: 4px;

}

.product-info-content-content-right-list-item-right {
  padding: 0 10px;
  flex: 1;
  height: 48px;
  text-align: left;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  word-break: break-all;
  /* 在恰当的断字点进行换行 */
  overflow: hidden;
  /* 超出范围隐藏 */
  text-overflow: ellipsis;
  /* 文字超出用省略号 */
  display: -webkit-box;
  /* 盒子模型 */
  -webkit-line-clamp: 2;
  /* 显示的文本行数 */
  -webkit-box-orient: vertical;
  /* 子元素的垂直排列方式 */
}

.product-info-content-content-right-list-item-left-time {
  text-align: right;
  font-size: 12px;
  color: rgba(51, 51, 51, 1);
}

.product-info-content-content-right-list-item-left-circle {
  text-align: right;
  color: rgba(32, 129, 235, 1);
  font-size: 24px;
}

::v-deep(.product-info-content-html img) {
  max-width: 100%;
}

.product-info-content-page-button-text {
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-info-content-page-button-text-right {

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
}

.product-info-content-page-button-right {
  width: 45%;
  height: 46px;
  background: rgba(248, 250, 250, 1);
  padding-left: 10px;
  display: flex;
  align-items: center;

  cursor: pointer;
  padding-right: 10px;
}

.product-info-content-back:hover {
  color: rgba(32, 129, 235, 1);
}

.product-info-footer-share {
  position: absolute;
  left: 13%;
  top: 100px;
}
</style>